import React from 'react';
import { Box, Typography } from '@mui/material';
import './styles.scss';

export default function SugestoesInput({ sugestoes, indiceSelecionado, aoSelecionar }) {
  if (sugestoes.length === 0) return null;

  return (
    <Box className="chat-ia-sugestoes-input" role="listbox" id="chat-ia-sugestoes-lista">
      {sugestoes.map((sugestao, indice) => (
        <Box
          key={sugestao.slug}
          component="button"
          type="button"
          id={`chat-ia-sugestao-${indice}`}
          role="option"
          aria-selected={indice === indiceSelecionado}
          className={`chat-ia-sugestoes-input-item ${indice === indiceSelecionado ? 'selecionada' : ''}`}
          onMouseDown={evento => evento.preventDefault()}
          onClick={() => aoSelecionar(sugestao.texto)}
        >
          <Typography component="span">{sugestao.texto}</Typography>
          {sugestao.categoria && <Typography component="small">{sugestao.categoria}</Typography>}
        </Box>
      ))}
    </Box>
  );
}
